import React, { useEffect, useRef, useState } from "react";
import api from "../../../../../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import {
  course_demo_image,
  Teacher_Dashboard_Default_NEW,
  Teacher_Dashboard_Default,
  archive_btn,
} from "../../../../../../assets/images/images";
//import { MenuItem } from "@mui/base";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";
import StyledMenu from "../../../../../../components/StyleMenu";
import PaginationView from "../../../../../../components/Pagination/PaginationView";
import { getAllCoursesByTeacherId } from "../../../../../../state/actions/getAllCoursesByTeacherIdAction";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import Card from "../course/Card";
import { toast } from "react-toastify";
import DescriptionCoursePopup from "../course/DescriptionCoursePopup";
import CourseDescriptionPreview from "../../../../../../context/CourseDescriptionPreview";

// const CourseItem = React.memo(({ course }) => {
//   const paragraphRef = useRef(null);
//   const [showViewMore, setShowViewMore] = useState(false);
//   const [descriptionOpen, setDescriptionOpen] = useState(false);
//   const descriptionToggle = () => {
//     setDescriptionOpen(!descriptionOpen);
//   };
//   useEffect(() => {
//     const el = paragraphRef.current;
//     if (!el) return;

//     const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
//     if (!lineHeight || isNaN(lineHeight)) return;

//     // ✅ scrollHeight = actual content height (ignores CSS clipping)
//     // ❌ clientHeight = visible height only (affected by overflow/clamp CSS)
//     const lineCount = el.scrollHeight / lineHeight;

//     setShowViewMore(lineCount > 2 || (course?.description?.length ?? 0) > 1000);
//   }, [course?.description]);

//   return (
//     <div className="teacherviewcoursedetails-des-wrapper">
//       <p className="teacherviewcoursedetails-des" ref={paragraphRef}>
//         {course?.description}
//         {showViewMore && (
//           <span className="view-more" onClick={() => setDescriptionOpen(true)}>
//             ...View More
//           </span>
//         )}
//       </p>
//       {descriptionOpen && (
//         <DescriptionCoursePopup
//           title="My Course Description"
//           data={course?.description}
//           onClick={() => setDescriptionOpen(false)}
//         />
//       )}
//     </div>
//   );
// });

const MyCourses = ({
  toggleDeleteCourse,
  toggleArchiveCourse = () => {},
  pendingArchives,
  undoArchive,
  setSelectedCourse,
  nextUrl,
  prevUrl,
  handlePageChange,
  totalPages,
  currentPage,
}) => {
  const globalState = useSelector((state) => state.globalState);
  const currency_symbol = useSelector(
    (state) => state?.globalState?.currency_symbol,
  );
  // Use global state for courses instead of Redux state to avoid duplicate API calls
  const { message } = useSelector((state) => state.syncSchoology);
  const [activeMenuCourseId, setActiveMenuCourseId] = useState(null);
  const [, forceRender] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { token } = useAuth();
  // const myCourses = globalState.course_list ?? [];
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const deleteCourse = async (course_id) => {
    setSelectedCourse(course_id);
    toggleDeleteCourse();
    handleClose();
    setShowOptions(null);
    document.body.style.overflow = "hidden";
  };

  const handleArchiveCourse = async (course) => {
    setSelectedCourse(course.name);
    toggleArchiveCourse(course, course.is_archived);
    setShowOptions(null);
    document.body.style.overflow = "hidden";
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const menuRef = useRef(); // Reference to the dropdown menu

  // Function to close the dropdown when clicking outside of it
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setTimeout(() => {
        setShowOptions(null);
      }, 100);
    }
  };

  // Setup click event listener
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleOptions = (index) => {
    if (showOptions === index) {
      setShowOptions(null); // If the options for this course are currently displayed, hide them
    } else {
      setShowOptions(index); // Otherwise, show the options for this course
    }
  };
  const [showOptions, setShowOptions] = useState(false);

  const onViewCourseClick = async (course) => {
    navigate(`/course/${course.course_id}/view`, {
      state: { course, teacher_id, from: location.pathname },
    });
  };
  const onEditCourseClick = async (course) => {
    setShowOptions(null);
    navigate(`/course/${course.course_id}/edit`, {
      state: { course, teacher_id },
    });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event, courseId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuCourseId(courseId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenuCourseId(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAllCoursesByTeacherId(currentPage, teacher_id, token));
  }, [currentPage, teacher_id, message, dispatch, token]);
  const getRemainingSeconds = (expiresAt) => {
    return Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      forceRender((p) => p + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const myCourses = useSelector(
    (state) => state.getallCoursesByTeacherId.courses,
  );
  return (
    <>
      <div className="created-my-courses-container">
        {/* Loading state is now handled by TeacherDashboard */}
        {myCourses && myCourses.length > 0 ? (
          myCourses.map((course, index) => (
            <div
              key={index}
              className={`created-my-courses-folder gap-6 relative ${
                pendingArchives[course.course_id] ? "blur-sm bg-[#EDEDED] " : ""
              }`}
            >
              <div className="created-my-courses-folder-image-left-folder">
                <div
                  className="created-my-courses-folder-image "
                  onClick={() => onViewCourseClick(course)}
                >
                  <img src={course.image || course_demo_image} alt="" />
                </div>
              </div>
              <div className="created-my-courses-des-wrapper">
                <div className="created-my-courses-title-folder">
                  <div className="created-my-courses-title-wrapper w-[95%] sm:w-[100%]">
                    <h2 onClick={() => onViewCourseClick(course)}>
                      {course.name}
                    </h2>
                    {globalState.enabled_modules?.includes('marketplace') && (
                      <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                            <a> <i className="fa-solid fa-star"></i> </a>
                            <p className="rate">{course?.average_course_rating || "0"}</p>
                            <p className="number">({parseInt(course?.rating_count || 0)})</p>
                      </div>
                    )} 
                  </div>
                  {course.my_role !== "viewer" && (
                    <div className="edit-course-dropdown-menu-container">
                      <div
                        className="edit-course-or-delete-course"
                        onClick={(e) => handleClick(e, course.course_id)}
                      >
                        <i className="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                      <StyledMenu
                        id="demo-customized-menu"
                        anchorEl={anchorEl}
                        open={Boolean(
                          anchorEl && activeMenuCourseId === course.course_id,
                        )}
                        onClose={handleClose}
                      >
                        <MenuItem
                          onClick={() => {
                            if (activeMenuCourseId === course.course_id) {
                              onEditCourseClick(course);
                            }
                            handleClose();
                          }}
                          disableRipple
                        >
                          <button
                            type="button"
                            className="course-edit-or-delete-folder"
                          >
                            <a href="#">
                              <i className="fa-solid fa-pencil"></i>
                            </a>
                            <p>Edit</p>
                          </button>
                        </MenuItem>
                        {(course.my_role === "owner" ||
                          globalState.role === "Admin") &&
                          globalState.enabled_modules?.includes(
                            "year2year",
                          ) && (
                            <MenuItem
                              onClick={() => {
                                if (activeMenuCourseId === course.course_id) {
                                  handleArchiveCourse(course);
                                }
                                handleClose();
                              }}
                              disableRipple
                            >
                              <button
                                type="button"
                                className="course-edit-or-delete-folder"
                              >
                                <img
                                  className="h-4 w-4"
                                  src={archive_btn}
                                  alt="archive_btn"
                                />
                                <p>
                                  {course.is_archived ? "Unarchive" : "Archive"}{" "}
                                  Course
                                </p>
                              </button>
                            </MenuItem>
                          )}
                        {course.my_role === "owner" && (
                          <MenuItem
                            onClick={() => {
                              if (activeMenuCourseId === course.course_id) {
                                deleteCourse(course.course_id);
                              }
                              handleClose();
                            }}
                            disableRipple
                          >
                            <button
                              type="button"
                              className="course-edit-or-delete-folder"
                            >
                              <a href="#">
                                <i className="fa-solid fa-trash"></i>
                              </a>
                              <p>Delete</p>
                            </button>
                          </MenuItem>
                        )}
                      </StyledMenu>
                    </div>
                  )}
                </div>
                <div className="Students-courses-details-container">
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Students Enrolled</span>
                    <div className="Students-courses-details-counts">
                      <p>{course.enrolled_students}</p>
                      <p>
                        {course.enrolled_students > 1
                          ? "Students"
                          : "Student"}{" "}
                      </p>
                    </div>
                  </div>

                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Total Lessons</span>
                    <div className="Students-courses-details-counts">
                      <p>{course.lesson_count}</p>
                      <p>{course.lesson_count > 1 ? "Lessons" : "Lesson"} </p>
                    </div>
                  </div>
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Course Start Date</span>
                    <div className="Students-courses-details-counts">
                      <p>
                        {course.start_date !== null && course.start_date !== ""
                          ? dayjs(course.start_date).format("MMM DD, YYYY")
                          : "- -"}
                      </p>
                    </div>
                  </div>
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Course Expiry Date</span>
                    <div className="Students-courses-details-counts">
                      <p>
                        {course.end_date !== null && course.end_date !== ""
                          ? dayjs(course.end_date).format("MMM DD, YYYY")
                          : "- -"}
                      </p>
                    </div>
                  </div>
                  {/* Marketplace: Total Revenue display */}
                  {globalState.enabled_modules?.includes("marketplace") &&
                    course?.price !== null &&
                    course?.total_revenue !== null &&
                    course?.my_role === "owner" && (
                      <div className="Students-courses-details-folder">
                        <span>Total Revenue</span>
                        <div className="Students-courses-details-counts">
                          <p>
                            {course.total_revenue !== null &&
                              course.total_revenue !== "" && (
                                <p>
                                  {course?.currency_symbol ?? currency_symbol}{" "}
                                  {course.total_revenue}
                                </p>
                              )}
                          </p>
                        </div>
                      </div>
                    )}
                </div>
                {/* <p
                  className="Students-des"
                  onClick={() => onViewCourseClick(course)}
                >
                  {course.description}
                </p> */}
                {/* <CourseItem key={course.course_id} course={course} /> */}

                <CourseDescriptionPreview
                  description={course.description}
                  PopupComponent={DescriptionCoursePopup}
                  popupTitle="My Course Description"
                />
                <div className="flex items-center gap-3 mt-4">
                  <button
                    type="button"
                    onClick={() => onViewCourseClick(course)}
                    className="View-Course"
                  >
                    View Course
                  </button>
                  {pendingArchives[course.course_id] && (
                      <button
                        type="button"
                        onClick={() => undoArchive(course.course_id)}
                        className="flex items-center gap-1 text-[#0068FF] border-none underline rounded-md text-sm bg-transparent"
                      >
                        Undo
                      <span className="text-sm font-medium text-[#0068FF]">
                        {getRemainingSeconds(
                          pendingArchives[course.course_id].expiresAt,
                        )}
                      </span>
                      </button>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <>
            <Card
              image={Teacher_Dashboard_Default_NEW}
              title="Craft an Interactive Course"
              description="Crafting an interactive course involves designing engaging lessons with quizzes and activities to actively involve students in the learning process"
            />
            <Card
              image={Teacher_Dashboard_Default}
              title="Build an Exciting Learning Journey"
              description="Crafting an exciting learning journey involves designing engaging educational experiences that captivate students and ignite their curiosity"
            />
          </>
        )}
      </div>
      {/* Add pagination back */}
      {totalPages > 1 && (
        <PaginationView
          totalPages={totalPages}
          next={nextUrl}
          previous={prevUrl}
          currentPage={currentPage}
          setCurrentPage={(page) => handlePageChange(null, page)}
        />
      )}
    </>
  );
};

export default MyCourses;
